export default "__VITE_ASSET__DLcCOE7r__"